import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hover?: boolean;
}

export const Card = ({ children, hover = false, className = '', ...props }: CardProps) => {
  return (
    <div
      className={`card-dark ${hover ? 'card-dark-hover' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

